const config = {
  // cityPairsURL: (lang) => `http://www.smartwings.com/external/data/booking/?lang=${lang}`,
  cityPairsURL: (lang) => `data/booking/citiesCombination_${lang}.json`,
  langs: ['en', 'cs', 'sk', 'de', 'it', 'fr', 'es', 'hu', 'ru'],
  submitURL: (lang) => `http://bookings.smartwings.com/${lang}/?`
}

module.exports = config



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/